export function smoothScrollToElement(nodeId: string): void {
  const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

  const element = document.getElementById(nodeId);
  const main = document.querySelector('.app__main');
  const top = element?.getBoundingClientRect().top;

  if (top) {
    if (isSmoothScrollSupported) {
      window.scrollTo({
        top,
        left: 0,
        behavior: 'smooth',
      });
      main?.scrollTo({
        top: top - 68,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo(0, top);
      main?.scrollTo(0, top - 68);
    }
  }
}

export async function nextAnimationFrame(): Promise<void> {
  return new Promise((res) => {
    requestAnimationFrame(() => res());
  });
}

export interface DownloadLink {
  blob?: Blob;
  url?: string;
  filename?: string;
}

export async function downloadFiles(links: DownloadLink[]): Promise<void> {
  // Create a link to trigger download
  for (const link of links) {
    const temporaryDownloadLink = document.createElement('a');
    temporaryDownloadLink.style.display = 'none';
    document.body.append(temporaryDownloadLink);

    if (link.blob) {
      temporaryDownloadLink.href = window.URL.createObjectURL(link.blob);
    }
    if (link.url) {
      temporaryDownloadLink.href = link.url;
    }
    temporaryDownloadLink.download = link.filename || 'document';
    temporaryDownloadLink.target = '_blank';

    temporaryDownloadLink.click();

    temporaryDownloadLink.remove();
  }
}

export function highlightElements(elementsQuery: string): void {
  const elements = document.querySelectorAll(elementsQuery);

  elements.forEach((element) => {
    const removeClass = (): void => {
      element.classList.remove('highlight');
      element.removeEventListener('animationend', removeClass);
    };

    element.classList.add('highlight');
    element.addEventListener('animationend', removeClass);
  });
}
